if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.preOrderAvailable = this.dataset.preOrder
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        this.cartItems = this.cart
          ? this.cart.querySelector('cart-items')
          : null
        this.submitButton = this.querySelector('[type="submit"]')
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog')
        document.addEventListener('addToCartError', (e) => {
          this.errorMessageDisplay(e)
        })
        // Create custom icons for gift message and gift wrap
        const setupIcons = () => {
          this.setupMessageOnly(this)
          this.setupGiftWrap(this)
        }
        // Create a mutation observer to observe the DOM and setup custom icons once the widget has been injected
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === 'attributes' &&
              mutation.target.nodeName === 'WRAPPED-PRODUCT-PROVIDER'
            ) {
              setupIcons()
            }
          })
        })

        observer.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
        })
      }

      // Create message icon element
      createMessageIcon = () => {
        const messageSvg = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'svg'
        )
        // ... setup messageSvg attributes ...
        messageSvg.setAttribute('width', '16')
        messageSvg.setAttribute('height', '15')
        messageSvg.setAttribute('viewBox', '0 0 16 15')
        messageSvg.setAttribute('fill', 'none')
        messageSvg.style.marginRight = '10px'
        messageSvg.style.marginLeft = '1px'

        // Create the path element
        const path = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'path'
        )
        path.setAttribute(
          'd',
          'M8 3.92832C8 3.15168 7.705 2.40685 7.1799 1.85769C6.6548 1.30852 5.94261 1 5.2 1H1V11.9812H5.9C6.45695 11.9812 6.9911 12.2126 7.38492 12.6245C7.77875 13.0363 8 13.595 8 14.1774M8 3.92832V14.1774M8 3.92832C8 3.15168 8.295 2.40685 8.8201 1.85769C9.3452 1.30852 10.0574 1 10.8 1H15V11.9812H10.1C9.54305 11.9812 9.0089 12.2126 8.61508 12.6245C8.22125 13.0363 8 13.595 8 14.1774'
        )
        path.setAttribute('stroke', '#1E1E1E')
        path.setAttribute('stroke-width', '1.46416')
        path.setAttribute('stroke-linecap', 'round')
        path.setAttribute('stroke-linejoin', 'round')

        // Append the path to the SVG
        messageSvg.appendChild(path)

        return messageSvg
      }

      // Create gift wrap image element
      createGiftWrapImage = () => {
        const img = new Image()
        img.src =
          'https://cdn.shopify.com/s/files/1/0770/2878/6454/files/Screenshot_2024-09-09_at_2.46.52_PM_3_2.png?v=1727308999'
        img.style.width = '18px'
        img.style.height = '18px'
        img.style.marginRight = '10px'
        return img
      }

      // Setup message only element
      setupMessageOnly = (wrappedCartItem) => {
        let shopUrl = window.location.href
        let disableGiftMessage = '49919364825380'

        if (shopUrl.includes('dev')) {
          disableGiftMessage = '49141998190870'
        }

        const messageOnly = wrappedCartItem.querySelector(
          `[data-variant-id="${disableGiftMessage}"]`
        )
        if (messageOnly && !messageOnly.querySelector('svg')) {
          const title = messageOnly.querySelector('span[part="title"]')
          if (title) {
            const messageSvg = this.createMessageIcon()
            title.prepend(messageSvg)
          }
        }
      }

      // Setup gift wrap element
      setupGiftWrap = (wrappedCartItem) => {
        let shopUrl = window.location.href
        let disableGiftWrap = '49919347261732'

        if (shopUrl.includes('dev')) {
          disableGiftWrap = '46392720195862'
        }
        const giftWrap = wrappedCartItem.querySelector(
          `[data-variant-id="${disableGiftWrap}"]`
        )
        if (giftWrap) {
          const giftTitle = giftWrap.querySelector('span[part="title"]')
          if (!giftTitle.querySelector('img')) {
            const img = this.createGiftWrapImage()
            giftTitle.prepend(img)
          }
        }
      }

      onSubmitHandler(evt) {
        async function fetchCartData() {
          const response = await fetch('/cart.js')
          const cart = await response.json()
          return cart
        }
        const mattressFee = this.getAttribute('data-mattress-fee')

        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('animate-pulse')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        const quantity = formData.get('quantity')

        const updateCartSections = () => {
          const getSectionsToRender = [
            {
              id: 'CartDrawer',
              section: 'cart-drawer',
              selector: 'data-cart-inner',
            },
            {
              id: 'cart-icon-bubble',
              section: 'cart-icon-bubble',
              selector: '.shopify-section',
            },
          ]

          const sectionIds = getSectionsToRender.map(
            (section) => section.section
          )

          fetch(`/?sections=${sectionIds}`, {
            headers: { Accept: 'application/json' },
          }).then((response) => {
            if (!response.ok) {
              quantityElement.value = quantityElement.getAttribute('value')
              this.cart.updateLiveRegions(line, response.statusText)
              return
            }

            response.json().then((sectionUpdateData) => {
              // Render section updates
              this.cart.renderContents({ sections: sectionUpdateData })
            })
          })
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((data) => {
            if (data.status && !this.preOrderAvailable) {
              this.handleErrorMessage(data.description)

              const soldOutMessage = this.submitButton.querySelector(
                '[data-product-form-error-message]'
              )
              if (
                data.status === 422 &&
                data.description.includes('due to availability')
              ) {
                setTimeout(() => {
                  updateCartSections()
                }, 2000)
              }
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButton.querySelector('span').classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            // Check if there is a mattressFee and add it
            if (mattressFee !== null) {
              const baseDomain = window.location.origin
              const isDevOrLocalhost =
                baseDomain.includes('dev') || baseDomain.includes('localhost')

              const mattressFeeIds = isDevOrLocalhost
                ? '49546542776598'
                : '49546542776598' // Replace with your mattress fee variant IDs
              const maxQuantity = 1
              var cartItem = null

              // Fetch current cart data
              fetchCartData()
                .then((cart) => {
                  const mattressFeeIdArray = mattressFeeIds.split(',')
                  cartItem = cart.items.find((item) =>
                    mattressFeeIdArray.includes(item.id.toString())
                  )
                })
                .catch((error) => {
                  console.error('Error fetching cart data:', error)
                })
                .finally(() => {
                  if (cartItem && cartItem.quantity >= maxQuantity) {
                    const cartItemError = document.querySelector(
                      '[data-cart-item-error-text]'
                    )
                    const showError = cartItemError.closest('div')
                    cartItemError.textContent = `You can only add up to ${maxQuantity} of this item.`
                    showError.setAttribute('data-show', true)
                    showError.classList.remove('hidden')
                  } else {
                    const mattressFeeArray = mattressFee.split(',')
                    const addMattressFee = async (fee) => {
                      const mattressFeeFormData = new FormData()
                      mattressFeeFormData.append('id', fee)
                      if (fee != 49546542776598) {
                        mattressFeeFormData.append('quantity', quantity)
                      } else {
                        mattressFeeFormData.append('quantity', 1)
                        mattressFeeFormData.append('quantity_rule', 'max')
                        mattressFeeFormData.append('quantity_rule_value', 1) // Set the quantity rule value
                      }
                      mattressFeeFormData.append(
                        'sections_url',
                        window.location.pathname
                      )

                      const mattressFeeConfig = {
                        ...config,
                        body: mattressFeeFormData,
                      }

                      const response = await fetch(
                        `${routes.cart_add_url}`,
                        mattressFeeConfig
                      )
                      const mattressData = await response.json()

                      if (data.status && !this.preOrderAvailable) {
                        this.handleErrorMessage(mattressData.description)
                        const soldOutMessage = this.submitButton.querySelector(
                          '[data-product-form-error-message]'
                        )
                        if (!soldOutMessage) return
                        this.submitButton.setAttribute('aria-disabled', true)
                        this.submitButton
                          .querySelector('span')
                          .classList.add('hidden')
                        soldOutMessage.classList.remove('hidden')
                        this.error = true
                        return
                      } else if (!this.cart) {
                        window.location = window.routes.cart_url
                        return
                      }
                    }

                    const addAllMattressFees = async () => {
                      for (const fee of mattressFeeArray) {
                        await addMattressFee(fee)
                      }
                      this.error = false
                      updateCartSections()
                    }

                    addAllMattressFees()
                  }
                })
            }
            this.error = false
            this.cart.renderContents(data)
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('animate-pulse')
            if (this.cart && this.cart.getAttribute('data-empty') === 'true')
              this.cart.setAttribute('data-empty', false)
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled')
            }
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (errorMessage) {
          this.dispatchEvent(
            new CustomEvent('addToCartError', {
              detail: {
                errors: errorMessage,
              },
              bubbles: true,
            })
          )
        }
      }

      errorMessageDisplay(e) {
        let errorMessage =
          e.detail.errors && typeof e.detail.errors !== 'object'
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('[data-product-form-error]')
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '[data-product-form-error-message]'
          )

        this.errorMessageWrapper.toggleAttribute('aria-hidden', !errorMessage)
        this.errorMessage.innerText = e.detail.errors
        setTimeout(() => {
          this.errorMessageWrapper.setAttribute('aria-hidden', true)
          this.errorMessage.innerText = ''
        }, 3000)
      }
    }
  )
}
